import { createSlice } from '@reduxjs/toolkit';

const initialState = false;

const currentVistaPresentacionSlice = createSlice({
	name: 'currentVistaPresentacion',
	initialState,
	reducers: {
		setCurrentVistaPresentacionSlice: (state, action) => {
			return action.payload;
		}
	}
});

export const { setCurrentVistaPresentacionSlice } = currentVistaPresentacionSlice.actions;
export default currentVistaPresentacionSlice.reducer;
